import { constants, PICTURE_SIZE, UPLOAD_TYPE, IMAGE_TYPE } from '../../Constants/constants'
import { getString } from '../../helper/util'
import { Drawer, Autocomplete, TextField, Chip, Typography } from '@mui/material'
import { UploadImageV2 } from '../../Component/UploadImage/UploadImageV2'
import CheckboxGroupInput from '../../Component/Input/CheckboxGroupInput'
import DynamicDeviceForm from './DynamicArrOfObj'
import { ErrorMsg } from '../../Component/ErrorMsg/ErrorMsg'

export const formFields = ({
    resource,
    savedAppVersion,
    appVersionId = null,
    inputError,
    helperTextStylesClasses,
    normalTextStyleClasses,
    theme,
    onChangeInput,
    handleSaveImage,
}) => {
    const currentRole = localStorage.getItem(constants.LOCAL_STORAGE_KEY.ROLE)
    const isDeveloper = currentRole === constants.ROLE.DEVELOPER || currentRole === constants.ROLE.ROLE_SUPER_ADMIN
    const isBeta = savedAppVersion.status === "BETA"

    const isCreate = !appVersionId

    // const disableInput = !(isDeveloper && (isBeta || isCreate))
    const disableInput = !(isDeveloper)

    const androidArr = ['androidModern', 'androidLegacy', 'androidMpos']

    const fields = [
    // show `appVersion` input only for create form
    ...(isCreate
      ? [
          {
            className: 'full-size-input',
            size: constants.SIZE.SMALL,
            label: { resource: resource, key: 'appVersion' },
            value: savedAppVersion.appVersion,
            disableClearable: true,
            name: 'appVersion',
            isEndOfLine: true,
            md: 12,
            handleChange: (name, value) => onChangeInput(name, value),
            required: true,
            helperTextIcon: true,
            helperText: inputError['appVersion'],
            FormHelperTextProps: { className: helperTextStylesClasses.root },
            disabled: disableInput,
            variant: constants.STYLE.VARIANT.FILLED,
          },
        ]
      : []),
    // {
    //   type: constants.TYPE.TITLE,
    //   value: { resource: resource, key: "createTitle" },
    //   className: "sub-title",
    // },
    // {
    //   // className: 'edit-create-input',
    //   className: 'full-size-input',
    //   size: constants.SIZE.SMALL,
    //   label: { resource: resource, key: 'appVersion' },
    //   value: savedAppVersion.appVersion,
    //   disableClearable: true,
    //   name: 'appVersion',
    //   isEndOfLine: false,
    //   md: 2,
    //   handleChange: (name, value) => onChangeInput(name, value),
    //   required: true,
    //   helperTextIcon: true,
    //   helperText: inputError['appVersion'],
    //   FormHelperTextProps: { className: helperTextStylesClasses.root },
    //   disabled: disableInput
    // },
    {
      // className: `edit-create-input`,
      className: 'full-size-input',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'buildNumber' },
      value: savedAppVersion.buildNumber,
      name: 'buildNumber',
      type: constants.TYPE.NUMBER,
      disableClearable: true,
      isEndOfLine: false,
      // md: 2,
      handleChange: (name, value) => onChangeInput(name, value),
      required: true,
      helperTextIcon: true,
      helperText: inputError['buildNumber'],
      FormHelperTextProps: { className: helperTextStylesClasses.root },
      disabled: disableInput,
      variant: constants.STYLE.VARIANT.FILLED,
    },
    // {
    //   // className: `edit-create-input`,
    //   className: 'full-size-input',
    //   size: constants.SIZE.SMALL,
    //   label: { resource: resource, key: 'customCode' },
    //   value: savedAppVersion.customCode,
    //   name: 'customCode',
    //   disableClearable: true,
    //   isEndOfLine: false,
    //   md: 2,
    //   handleChange: (name, value) => onChangeInput(name, value),
    //   // required: true,
    //   helperTextIcon: true,
    //   helperText: inputError['customCode'],
    //   FormHelperTextProps: { className: helperTextStylesClasses.root },
    //   disabled: disableInput,
    // },
    {
      // className: 'edit-create-input',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'buildTarget' },
      type: constants.TYPE.CUSTOM,
      name: 'buildTarget',
      isEndOfLine: false,
      // md: 4,
      customContent: (
        <div className='full-size-input' style={{ display: 'inline-flex', flexDirection: 'column' }}>
          <CheckboxGroupInput
            label={getString('', resource, 'buildTarget', theme)}
            options={constants.CHOICES.APP_VERSION.BUILD_TARGET_LOWER}
            value={savedAppVersion.buildTarget}
            onChange={(newVal) => onChangeInput('buildTarget', newVal)}
            disabled={disableInput}
          />
          {inputError['buildTarget'] && (<ErrorMsg errorMsg={inputError['buildTarget']} />)}
        </div>
      )
    },
    // {
    //   className: 'edit-create-input',
    //   size: constants.SIZE.SMALL,
    //   label: { resource: resource, key: 'status' },
    //   value: savedAppVersion.status,
    //   type: constants.TYPE.SELECT,
    //   selectValue: constants.CHOICES.APP_VERSION.STATUS,
    //   name: 'status',
    //   isEndOfLine: true,
    //   required: true,
    //   helperTextIcon: true,
    //   helperText: inputError['status'],
    // },
    // {
    //   // className: 'edit-create-input',
    //   className: 'full-size-input',
    //   size: constants.SIZE.SMALL,
    //   label: { resource: resource, key: 'documentList' },
    //   value: savedAppVersion.documentList,
    //   selectValue: [],
    //   type: constants.TYPE.CUSTOM,
    //   name: 'documentList',
    //   freeSolo: true,
    //   multiple: true,
    //   isEndOfLine: true,
    //   md: 8,
    //   customContent: (
    //       <div 
    //         className={'full-size-input'}
    //         style={{ display: 'inline-flex', flexDirection: 'column', width: '100%', verticalAlign: 'top' }}>
    //         <DynamicDeviceForm
    //           label={getString(
    //             '',
    //             resource,
    //             'documentList',
    //             theme
    //           )}
    //           value={savedAppVersion.documentList}
    //           handleChange={(value) => onChangeInput('documentList', value)}
    //           // disabled={disableInput}
    //         />
    //         {inputError['documentList'] && (<ErrorMsg errorMsg={inputError['documentList']} />)}
    //       </div>
    //   )
    // },
    // {
    //   // className: 'edit-create-input',
    //   className: 'full-size-input',
    //   size: constants.SIZE.SMALL,
    //   label: { resource: resource, key: 'releaseNote' },
    //   value: savedAppVersion.releaseNote,
    //   name: 'releaseNote',
    //   multiline: true,
    //   minRows: 4,
    //   md: 6,
    //   handleChange: (name, value) => onChangeInput(name, value),
    //   isEndOfLine: false,
    //   helperTextIcon: true,
    //   helperText: inputError['releaseNote'],
    //   disabled: disableInput,
    // },
    {
      // className: 'edit-create-input',
      className: 'full-size-input',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'remarks' },
      value: savedAppVersion.remarks,
      name: 'remarks',
      multiline: true,
      minRows: 4,
      // md: 6,
      handleChange: (name, value) => onChangeInput(name, value),
      isEndOfLine: true,
      helperTextIcon: true,
      helperText: inputError['remarks'],
      variant: constants.STYLE.VARIANT.FILLED,
    },
    {
      // className: 'edit-create-input',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'file' },
      value: savedAppVersion.file,
      selectValue: [],
      type: constants.TYPE.CUSTOM,
      name: 'file',
      freeSolo: true,
      multiple: true,
      isEndOfLine: true,
      // helperTextIcon: true,
      // helperText: inputError['file'],
      customContent: (
        <>
          {
            androidArr.some((item) => savedAppVersion.buildTarget?.[item]) && (
                <div className="image">
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>APK file</Typography>
                  <UploadImageV2
                    type={IMAGE_TYPE.APK}
                    title={{ resource: resource, key: 'file' }}
                    name="file"
                    fileType={"FILE"}
                    saveImage={handleSaveImage}
                    picture={savedAppVersion?.file?.cosFileUrl || savedAppVersion?.file?.cosFileKey ? savedAppVersion?.file : null}
                    uploadType={UPLOAD_TYPE.FORMDATA}
                    // uploadImagePath={constants.PATH.SHOP.UPLOAD_RESTAURANT_MEDIA}
                    uploadImagePath={'gulu-console/merchant/shop-app-release-upload-file'}
                    size={PICTURE_SIZE.LARGE}
                    allowedFileExtensionList={['.apk', 'application/vnd.android.package-archive']}
                    removeImage={() => onChangeInput('file', null)}
                    // showApplyToAll={true}
                    disableInput={disableInput}
                  />
                  {inputError['file'] && (<ErrorMsg errorMsg={inputError['file']} />)}
                </div>
            )
          }
        </>
      )
    },
    {
      // className: 'edit-create-input',
      className: 'full-size-input',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'tagList' },
      value: savedAppVersion.tagList,
      selectValue: [],
      type: constants.TYPE.CUSTOM,
      name: 'tagList',
      freeSolo: true,
      multiple: true,
      isEndOfLine: true,
      // md: 3,
      customContent: (
            <Autocomplete
              className={'full-size-input'}
              sx={{ display: 'inline-flex', flexDirection: 'column', width: '100%' }}
              size={constants.SIZE.SMALL}
              multiple
              options={[]}
              freeSolo
              disabled={disableInput}
              renderTags={(value, getTagProps) => {
                const newValue = value && Array.isArray(value) && value.length > 0 ? value : []

                return (
                  newValue.map((option, index) => (
                    <Chip
                        key={index}
                        variant='outlined'
                        color='primary'
                        label={option}
                        {...getTagProps({ index })}
                    />
                  ))
                )
              }
              }
              renderInput={(params) => {

                return (
                  <TextField
                      {...params}
                      className={normalTextStyleClasses.label}
                      variant={constants.STYLE.VARIANT.FILLED}
                      InputLabelProps={{ shrink: true }}
                      placeholder={'Enter tag and press enter'}
                      label={getString(
                          '',
                          resource,
                          'tagList',
                          theme
                      )}
                  />
              )
              }}
              onChange={(event, value) => onChangeInput('tagList', value)}
              value={savedAppVersion.tagList ?? []}
        />
      )
    },
  ]

  return fields
}